export default "__VITE_ASSET__OZmYRnUN__"